import ENV from '@env/index'
import { DispatchType } from '@redux/types'
import info from '@utils/info'
import storage from '@utils/storage'
import { UserData } from '../interfaces/UserData'
import { setAuthLoading, setAuthLogin } from '../reducers/authReducer'

export default function getUser(dispatch: DispatchType){
    try {
        const localUser = storage.getObject<UserData>('user')
        const localFlasgSystem = storage.getItem<string>('flagSystem')
        
        if(!!localUser && localUser.nome){
            if(!!localFlasgSystem && localFlasgSystem === ENV.FLAG_SYSTEM){
                dispatch(setAuthLogin(localUser))
            }else{
                storage.clear()
                throw new Error('Flag System not found')
            }
        }else throw new Error('User not found')
    } catch (error) {
        info.error('getUser',error)
    } finally {
        dispatch(setAuthLoading(false))
    }
}